import { useAction } from '@reatom/npm-react'
import { AnimatePresence, motion } from 'motion/react'
import { useState } from 'react'
import styled from 'styled-components'

import { CrossIcon } from '@blade/ui-kit'
import { CurrencyIcon } from '@root/entities/currency/ui'
import { PairLink } from '@root/entities/pair/ui/common'
import { deleteRecentSearchAction } from '@root/features/user/recent-searches'

import type { Pair, PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type SearchRecentPairItemProps = {
  pair: PairModel
  onClick?: (pair: Pair.PairMinimal) => void
} & ClassNameProps

export const SearchRecentPairItem: React.FC<SearchRecentPairItemProps> = ({
  className,
  pair,
  onClick,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const deleteRecentSearch = useAction(deleteRecentSearchAction)

  return (
    <Root
      onPointerEnter={() => setIsHovered(true)}
      onPointerLeave={() => setIsHovered(false)}
      className={className}
    >
      <Link pair={pair} onClick={() => onClick?.(pair)}>
        <CurrencyIcon
          size={28}
          currency={pair.quote}
          withNetwork
          pairAddress={pair.address}
        />
        <Symbol>{pair.quote.ticker}</Symbol>
      </Link>
      <AnimatePresence initial={false}>
        {isHovered ? (
          <motion.div
            layout
            initial={{ width: 0, opacity: 0 }}
            animate={{ width: 'auto', opacity: 1 }}
            exit={{ width: 0, opacity: 0 }}
            transition={{ ease: 'easeInOut' }}
            style={itemStyle}
          >
            <DeleteButton
              type="button"
              onClick={(e) => {
                e.stopPropagation()
                deleteRecentSearch({
                  network: pair.base.network,
                  pairAddress: pair.address,
                })
              }}
            >
              <CrossIcon size={12} />
            </DeleteButton>
          </motion.div>
        ) : undefined}
      </AnimatePresence>
    </Root>
  )
}

const itemStyle = {
  overflow: 'hidden',
}
const Root = styled.div`
  display: flex;
  align-items: center;

  cursor: pointer;
`
const Link = styled(PairLink)`
  display: flex;
  align-items: center;
`

const Symbol = styled.div`
  color: var(--text-12);

  font-size: 12px;
  font-weight: 500;
  padding-inline-start: 6px;
`

const DeleteButton = styled.button`
  color: var(--text-11);
  all: unset;
  display: grid;
  padding-inline-start: 6px;

  &:hover {
    color: var(--text-11);
  }
`
